import React from 'react';
import { useTranslation } from 'react-i18next';
import { HiHeart, HiBuildingOffice2, HiShieldCheck, HiExclamationTriangle, HiUserGroup } from 'react-icons/hi2';
import SectionTitle from '../components/SectionTitle';
import InfoBox from '../components/InfoBox';
import TabGroup, { TabPanel } from '../components/TabGroup';

const Health = () => {
  const { t } = useTranslation();

  return (
    <div className="space-y-8">
      <SectionTitle level={1} icon={HiHeart}>
        {t('health.title')}
      </SectionTitle>

      {/* Intro */}
      <div className="bg-teal-50 dark:bg-teal-900/30 border-s-4 border-teal-500 dark:border-teal-600 p-4 rounded-e-lg">
        <p className="text-gray-800 dark:text-gray-200 leading-relaxed">
          {t('health.intro')}
        </p>
      </div>

      <TabGroup>
        {/* TAB 1: VOS DROITS */}
        <TabPanel tabId="rights">
          <section>
            <SectionTitle level={2} icon={HiShieldCheck}>
              {t('health.rightsTitle')}
            </SectionTitle>
            <div className="bg-teal-50 dark:bg-teal-900/20 border-l-4 border-teal-600 dark:border-teal-400 p-4 rounded-r-lg">
              <ul className="space-y-3">
                {t('health.rightsItems', { returnObjects: true }).map((item, index) => (
                  <li key={index} className="flex items-start">
                    <span className="text-teal-600 dark:text-teal-400 mr-2 mt-1 font-bold">✓</span>
                    <span className="text-gray-900 dark:text-white font-medium">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </section>

          <section>
            <SectionTitle level={2} icon={HiShieldCheck}>
              {t('health.confidentialityTitle')}
            </SectionTitle>
            <ul className="space-y-2">
              {t('health.confidentialityItems', { returnObjects: true }).map((item, index) => (
                <li key={index} className="flex items-start">
                  <span className="text-teal-600 dark:text-teal-400 mr-2 mt-1">•</span>
                  <span className="text-gray-700 dark:text-gray-300">{item}</span>
                </li>
              ))}
            </ul>
          </section>

          <section>
            <SectionTitle level={2} icon={HiUserGroup}>
              {t('health.womenChildrenTitle')}
            </SectionTitle>
            <ul className="space-y-2">
              {t('health.womenChildrenItems', { returnObjects: true }).map((item, index) => (
                <li key={index} className="flex items-start">
                  <span className="text-teal-600 dark:text-teal-400 mr-2 mt-1">•</span>
                  <span className="text-gray-700 dark:text-gray-300">{item}</span>
                </li>
              ))}
            </ul>
          </section>
        </TabPanel>

        {/* TAB 2: DÉMARCHES */}
        <TabPanel tabId="procedures">
          <section>
            <SectionTitle level={2} icon={HiBuildingOffice2}>
              {t('health.accessTitle')}
            </SectionTitle>
            <ul className="space-y-2">
              {t('health.accessItems', { returnObjects: true }).map((item, index) => (
                <li key={index} className="flex items-start">
                  <span className="text-teal-600 dark:text-teal-400 mr-2 mt-1">•</span>
                  <span className="text-gray-700 dark:text-gray-300">{item}</span>
                </li>
              ))}
            </ul>
          </section>

          <InfoBox type="conseil" title={t('health.proceduresTipTitle')}>
            <p>{t('health.proceduresTipContent')}</p>
          </InfoBox>
        </TabPanel>

        {/* TAB 3: SI PROBLÈME */}
        <TabPanel tabId="problems">
          <InfoBox type="important" title={t('health.importantTitle')}>
            <p>{t('health.importantContent')}</p>
          </InfoBox>

          <section>
            <SectionTitle level={2} icon={HiExclamationTriangle}>
              {t('health.problemsTitle')}
            </SectionTitle>
            <ul className="space-y-2">
              {t('health.problemsItems', { returnObjects: true }).map((item, index) => (
                <li key={index} className="flex items-start">
                  <span className="text-orange-600 dark:text-orange-400 mr-2 mt-1">!</span>
                  <span className="text-gray-700 dark:text-gray-300">{item}</span>
                </li>
              ))}
            </ul>
          </section>

          <InfoBox type="danger" title={t('health.urgentTitle')}>
            <p>{t('health.urgentContent')}</p>
          </InfoBox>
        </TabPanel>
      </TabGroup>
    </div>
  );
};

export default Health;
